import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { PasswordInput } from "../components/PasswordInput";
import { Label } from "../components/ui/label";

export default function SetPassword() {
  const { user, refresh, isOfficer } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", pw);
      await refresh();
      toast.success("Password set. Akwaaba!");
      nav(isOfficer ? "/admin" : "/portal", { replace: true });
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6" data-testid="set-password-page">
      <div className="glass w-full max-w-md rounded-2xl p-8">
        <p className="eyebrow text-gold">Welcome{user?.name ? `, ${user.name.split(" ")[0]}` : ""}</p>
        <h1 className="font-serif-display mt-1 text-3xl font-bold text-crimson">Choose your password</h1>
        <p className="mt-2 text-sm text-muted-foreground">You signed in with a temporary password. Please set a new one before continuing.</p>
        <div className="mt-6 space-y-3">
          <div><Label>Temporary password</Label><PasswordInput value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} testId="set-password-current" /></div>
          <div><Label>New password (min 8 characters)</Label><PasswordInput value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} testId="set-password-new" /></div>
          <Button onClick={submit} disabled={busy || pw.new_password.length < 8 || !pw.current_password} className="w-full bg-crimson" data-testid="set-password-submit">
            {busy ? <Loader2 className="animate-spin" /> : <><KeyRound size={16} className="mr-1" /> Save new password</>}
          </Button>
        </div>
      </div>
    </div>
  );
}
